import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import * as pbi from 'powerbi-client';
import { connect } from 'react-redux';
import _ from 'lodash';

import Powerbi from '../components/Powerbi';
import { requestClientReport } from '../../../store/power-bi/PowerBiActions';
import { isOrganizationalClient, isExternalStakeholder } from '../../../store/current-user/CurrentUserSelectors';
import { hostTitle } from '../../../config/ui';

class ClientReport extends Component {
  constructor(props) {
    super(props);

    this.state = { client: null, clientFilter: null, showInfo: false };
  }

  componentWillMount() {
    this.props.getClientReport();
  }

  getClientFilters = (name) => ([
    new pbi.models.AdvancedFilter(
      {
        table: 'Client Matrix',
        column: 'EmployerCodeDescription',
      },
      'And',
      [
        {
          operator: 'Is',
          value: name,
        },
      ],
    ),
  ]);

  onEmbedded = report => {
    const { isOrganizationalClient } = this.props;
    const { client, clientFilter } = this.state;
    if (isOrganizationalClient && client) {
      const name = client.name;
      report.on('loaded', function() {
        // report.getFilters().then(filters => console.log(filters));
        if (name) {
          return report.setFilters(clientFilter);
        }
      });
    }
  };

  shouldComponentUpdate(nextProp, nextState) {
    return !(
      _.isEqual(nextProp.reports.client, this.props.reports.client) &&
      _.isEqual(nextState.client, this.state.client) &&
      _.isEqual(nextState.clientFilter, this.state.clientFilter) &&
      this.state.client !== null
    );
  }

  componentWillReceiveProps(nextProps) {
    const {
      params,
      currentUser: { clients },
      isOrganizationalClient,
    } = this.props;

    if (!isOrganizationalClient) {
      return;
    }

    let currentClient = null;

    if (isOrganizationalClient && params.client && clients) {
      if (clients.some(el => el.name === params.client)) {
        currentClient = clients.find(el => el.name === params.client);
      }
    }
    if (isOrganizationalClient && !clients) {
      this.setState({
        showInfo: true
      });
    }
    if (currentClient) {
      this.setState({
        client: currentClient,
        clientFilter: this.getClientFilters(currentClient.name)
      });
    }
  }

  render() {
    const models = pbi.models;
    const { isOrganizationalClient, reports: { client: data } } = this.props;
    const { client, clientFilter, showInfo } = this.state;

    let filterProps = { filters: [] };

    if (isOrganizationalClient && client) {
      filterProps = { filters: clientFilter };
    }

    return (
      <div id="content">
        <Helmet title={`Client Reports – ${hostTitle()}`} />
        {showInfo && (
          <div className="well info">
              <h1 className="info text-center">You have no assigned clients to display reports.</h1>
          </div>
        )}
        {data.accessToken && !showInfo && (
          <Powerbi
            id={data.id}
            embedUrl={data.embedUrl}
            accessToken={data.accessToken}
            tokenType={models.TokenType.Embed}
            filterPaneEnabled={isOrganizationalClient ? false : true}
            navContentPaneEnabled={true}
            width="100%"
            height="600px"
            onEmbedded={this.onEmbedded}
            {...filterProps}
          />
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    reports: state.powerbi.reports,
    currentUser: state.currentUser.data,
    isOrganizationalClient: isOrganizationalClient(state) || isExternalStakeholder(state),
  }),
  dispatch => ({
    getClientReport: () => dispatch(requestClientReport()),
  }),
)(ClientReport);



// WEBPACK FOOTER //
// ./src/routes/reports-analytics/containers/ClientReport.js